import Vue from 'vue'
import Keycloak from 'keycloak-js'

const initOptionsDev = {
    url: 'https://connexstream.com/auth',
    realm: 'connex_stream_dev',
    clientId: 'frontend_earthreceiver',
};

const initOptionsProd = {
    url: 'https://connexstream.com/auth',
    realm: 'connex_stream_staging',
    clientId: 'frontend_earthreceiver',
};

const getInitOptions = () => {
    if(process.env.VUE_APP_STAGE === 'dev'){
        return initOptionsDev;
    }else if(process.env.VUE_APP_STAGE === 'prod'){
        return initOptionsProd;
    }else {
        return initOptionsDev;
    }
}

const _keycloak = new Keycloak(getInitOptions())

const Plugin = {
    install: Vue => {
        Vue.$keycloak = _keycloak;
    },
};

Plugin.install = Vue => {
    Vue.$keycloak = _keycloak;
    Object.defineProperties(Vue.prototype, {
        $keycloak: {
            get() {
                return _keycloak;
            },
        },
    });
};

Vue.use(Plugin);

export default Plugin;